import { IQuestion, IUser } from '../../services/nextpeakClient'
import { Me } from '../../MeProvider.ts'
import Card from '../../newComponents/Card/Card.tsx'
import { ElementType, Page, SurveyElement, SurveyJson } from '../SurveyBuilder.tsx'
import { Heading1 } from '../../newComponents/Headings/index.tsx'

const getQuestionType = (type: string | undefined | null): Omit<SurveyElement, 'name' | 'title' | 'isRequired' | 'description'> => {
	switch (type) {
		case 'range10':
		default:
			return { type: ElementType.RATING, rateCount: 10, rateValues: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
	}
}

export const formatQuestionText = (text: string, firstName: string, organizationName: string): string => {
	return text.replaceAll('{first_name}', firstName).replaceAll('{organization_name}', organizationName)
}

export const mapAssessmentSurveyData = (questions: IQuestion[], employee: IUser, me: Me): SurveyJson => {
	const iAmEmployee = me.id === employee.id

	const pages = questions.reduce((acc: Page[], item): Page[] => {
		const page = acc.find((pg: Page) => pg.name === `${item.name}-${item.subName}`)
		if (!page) {
			acc.push({
				title: `${item.name} / ${item.subName}`,
				name: `${item.name}-${item.subName}`,
				elements: [
					{
						name: item.id,
						title: formatQuestionText(iAmEmployee ? item.subordinateText : item.managerText, employee.name, me.activeOrg?.name!),
						...getQuestionType(item.responseType),
						isRequired: true,
						description: '1 = lowest; 10 = highest',
					},
				],
			})
		} else {
			page.elements.push({
				name: item.id,
				title: formatQuestionText(iAmEmployee ? item.subordinateText : item.managerText, employee.name, me.activeOrg?.name!),
				type: ElementType.RATING,
				rateCount: 10,
				rateValues: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
				isRequired: true,
				description: '1 = lowest; 10 = highest',
			})
		}
		return acc
	}, [])

	return {
		pages: [
			{
				elements: [
					{
						type: ElementType.HTML,
						content: (
							<Card>
								<Heading1 size="md" className="mb-4">
									Intro
								</Heading1>
								<p className="text-gray-600">
									This survey is designed to gather feedback on your performance and contributions. Please answer the questions honestly and
									to the best of your ability.
								</p>
							</Card>
						),
					},
				],
			},
			...pages.flat(),
		],
		pageNextText: 'Next',
		completeText: 'Submit',
		firstPageIsStarted: true,
		startSurveyText: 'Start',
		showProgressBar: true,
		showQuestionNumbers: true,
		showPreviewBeforeComplete: false,
	}
}
